import React from "react"
// import PropTypes from "prop-types"

import { parse } from "node-html-parser"

import { graphql, Script } from "gatsby"

import withRecombee from "../contexts/withRecombee"

import Code from "../components/layouts/Code"
import Cubewise from "../components/layouts/Cubewise"
import Edu from "../components/layouts/Edu"
import Support from "../components/layouts/Support"

import WorldChampionships from "../components/WorldChampionships"

import { CookieNotice } from "gatsby-cookie-notice"

import Seo from "../components/Seo"

import ComponentFactory from "../components/parsers/ComponentFactory"

import TM1FunctionDisplay from "../components/TM1FunctionDisplay"

const getPageFromData = (data, pageContext) => {
  if (!data.wpPage) return null

  const { nodes } = data.wpPage
  if (!nodes || !Array.isArray(nodes)) return null

  /* if (nodes.length !== 1)
    throw new Error(
      `Page slugs need to be unique! - duplicate ${
        pageContext.slug || `unknown`
      }`
    ) */

  return nodes[0]
}

const getPageCategories = page => {
  if (!page.categories) return null

  const { nodes } = page.categories
  if (!nodes || !Array.isArray(nodes)) return null

  return nodes.map(n => n.slug)
}

function DefaultPage(props) {
  const page = getPageFromData(props.data, props.pageContext)
  const pageCategories = getPageCategories(page)

  const brand =
    (pageCategories.includes(`education`) && `education`) ||
    (pageCategories.includes(`technical`) && `code`) ||
    (pageCategories.includes(`support`) && `support`) ||
    `cubewise`

  const pageContentWrapperProps = {
    className: props.pageContext.slug || "body-content",
    wpPage: props.data.wpPage,
    wpPosts: props.data.wpPosts.nodes,
    pageContext: { ...props.pageContext, brand: brand },
    modals: props.data.modals,
  }
  const pageComponents = ComponentFactory(page.content, pageContentWrapperProps)

  if (pageCategories.includes(`landing-pages`)) {
    let Theme = Cubewise
    if (pageCategories.includes(`world-championships`))
      Theme = WorldChampionships

    return (
      <>
        <Theme data={props.data} pageContext={props.pageContext}>
          {pageComponents}
          <CookieNotice
            personalizeButtonEnable={false}
            personalizeValidationText={"Accept"}
            declineButton={false}
            wrapperClasses={`d-flex justify-content-between`}
          >
            <h4>This websites uses cookies.</h4>
            <p>
              We use cookies on our website to give you the most relevant
              experience by remembering your preferences and repeat visits. By
              clicking “Accept”, you consent to the use of ALL the cookies.
            </p>
          </CookieNotice>
        </Theme>
        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NCX94J4');`,
          }}
        />

        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:5231787,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');;`,
          }}
        />

        <Script src="https://secure.leadforensics.com/Track/Capture.aspx?retType=js&amp;trk_jshv=1&amp;trk_uid=&amp;trk_user=98460&amp;trk_sw=2560&amp;trk_sh=1080&amp;trk_ref=https%3A%2F%2Fcubewise.com%2Fwp-admin%2Findex.php&amp;trk_tit=Homepage%20-%20Cubewise&amp;trk_loc=https%3A%2F%2Fcubewise.com%2F&amp;trk_agn=Netscape&amp;trk_agv=Mozilla%2F5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit%2F537.36%20(KHTML%2C%20like%20Gecko)%20Chrome%2F121.0.0.0%20Safari%2F537.36.lfcd24.lflng&amp;trk_dom=cubewise.com&amp;trk_cookie=NA" />

        {process.env.GATSBY_MATOMO_ID && (
          <Script
            dangerouslySetInnerHTML={{
              __html: `;var _paq=window._paq=window._paq||[];_paq.push(["trackPageView"]),_paq.push(["enableLinkTracking"]),_paq.push(["enableHeartBeatTimer"]),function(){_paq.push(["setTrackerUrl","https://apliqo.matomo.cloud/matomo.php"]),_paq.push(["setSiteId","10"]);var a=document,e=a.createElement("script"),t=a.getElementsByTagName("script")[0];e.async=!0,e.src="https://cdn.matomo.cloud/apliqo.matomo.cloud/matomo.js",t.parentNode.insertBefore(e,t)}();`,
            }}
          />
        )}
      </>
    )
  }

  if (pageCategories.includes(`education`))
    return (
      <>
        <Edu
          data={props.data}
          pageContext={{ ...props.pageContext, brand: `education` }}
        >
          <div className="row">
            <div className="col">{pageComponents}</div>
          </div>
          <CookieNotice
            personalizeButtonEnable={false}
            personalizeValidationText={"Accept"}
            declineButton={false}
            wrapperClasses={`d-flex justify-content-between`}
          >
            <h4>This websites uses cookies.</h4>
            <p>
              We use cookies on our website to give you the most relevant
              experience by remembering your preferences and repeat visits. By
              clicking “Accept”, you consent to the use of ALL the cookies.
            </p>
          </CookieNotice>
        </Edu>
        <Script
          src="https://cdn.jsdelivr.net/gh/recombee/js-api-client@4.0.0/dist/recombee-api-client.min.js"
          onLoad={() => props.recombee.Init()}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NCX94J4');`,
          }}
        />

        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:5231787,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');;`,
          }}
        />

        <Script src="https://secure.leadforensics.com/Track/Capture.aspx?retType=js&amp;trk_jshv=1&amp;trk_uid=&amp;trk_user=98460&amp;trk_sw=2560&amp;trk_sh=1080&amp;trk_ref=https%3A%2F%2Fcubewise.com%2Fwp-admin%2Findex.php&amp;trk_tit=Homepage%20-%20Cubewise&amp;trk_loc=https%3A%2F%2Fcubewise.com%2F&amp;trk_agn=Netscape&amp;trk_agv=Mozilla%2F5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit%2F537.36%20(KHTML%2C%20like%20Gecko)%20Chrome%2F121.0.0.0%20Safari%2F537.36.lfcd24.lflng&amp;trk_dom=cubewise.com&amp;trk_cookie=NA" />

        {/* <Script dangerouslySetInnerHTML={{
          __html: `;(function(o,l,a,r,k,y){if(o.olark)return;
            r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0];
            y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r);
            y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)};
            y.extend=function(i,j){y("extend",i,j)};
            y.identify=function(i){y("identify",k.i=i)};
            y.configure=function(i,j){y("configure",i,j);k.c[i]=j};
            k=y._={s:[],t:[+new Date],c:{},l:a};
            })(window,document,"static.olark.com/jsclient/loader.js");olark.identify('3897-515-10-6547');`}} /> */}
        {/* <Script dangerouslySetInnerHTML={{ __html: `;olarkElem = window.document.getElementById('hbl-live-chat-wrapper');if (olarkElem) olarkElem.style.display = "block";` }} /> */}

        {process.env.GATSBY_MATOMO_ID && (
          <Script
            dangerouslySetInnerHTML={{
              __html: `;var _paq=window._paq=window._paq||[];_paq.push(["trackPageView"]),_paq.push(["enableLinkTracking"]),_paq.push(["enableHeartBeatTimer"]),function(){_paq.push(["setTrackerUrl","https://apliqo.matomo.cloud/matomo.php"]),_paq.push(["setSiteId","10"]);var a=document,e=a.createElement("script"),t=a.getElementsByTagName("script")[0];e.async=!0,e.src="https://cdn.matomo.cloud/apliqo.matomo.cloud/matomo.js",t.parentNode.insertBefore(e,t)}();`,
            }}
          />
        )}
      </>
    )

  if (pageCategories.includes(`technical`))
    return (
      <>
        <Code
          data={props.data}
          pageContext={{ ...props.pageContext, brand: `code` }}
        >
          <div className="row">
            <div className="col">{pageComponents}</div>
          </div>
          <CookieNotice
            personalizeButtonEnable={false}
            personalizeValidationText={"Accept"}
            declineButton={false}
            wrapperClasses={`d-flex justify-content-between`}
          >
            <h4>This websites uses cookies.</h4>
            <p>
              We use cookies on our website to give you the most relevant
              experience by remembering your preferences and repeat visits. By
              clicking “Accept”, you consent to the use of ALL the cookies.
            </p>
          </CookieNotice>
        </Code>
        <Script
          src="https://cdn.jsdelivr.net/gh/recombee/js-api-client@4.0.0/dist/recombee-api-client.min.js"
          onLoad={() => props.recombee.Init()}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NCX94J4');`,
          }}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:5231787,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');;`,
          }}
        />

        <Script src="https://secure.leadforensics.com/Track/Capture.aspx?retType=js&amp;trk_jshv=1&amp;trk_uid=&amp;trk_user=98460&amp;trk_sw=2560&amp;trk_sh=1080&amp;trk_ref=https%3A%2F%2Fcubewise.com%2Fwp-admin%2Findex.php&amp;trk_tit=Homepage%20-%20Cubewise&amp;trk_loc=https%3A%2F%2Fcubewise.com%2F&amp;trk_agn=Netscape&amp;trk_agv=Mozilla%2F5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit%2F537.36%20(KHTML%2C%20like%20Gecko)%20Chrome%2F121.0.0.0%20Safari%2F537.36.lfcd24.lflng&amp;trk_dom=cubewise.com&amp;trk_cookie=NA" />
        {/* <Script dangerouslySetInnerHTML={{ __html: `;olarkElem = window.document.getElementById('hbl-live-chat-wrapper');if (olarkElem) olarkElem.style.display = "none";` }} /> */}

        {process.env.GATSBY_MATOMO_ID && (
          <Script
            dangerouslySetInnerHTML={{
              __html: `;var _paq=window._paq=window._paq||[];_paq.push(["trackPageView"]),_paq.push(["enableLinkTracking"]),_paq.push(["enableHeartBeatTimer"]),function(){_paq.push(["setTrackerUrl","https://apliqo.matomo.cloud/matomo.php"]),_paq.push(["setSiteId","10"]);var a=document,e=a.createElement("script"),t=a.getElementsByTagName("script")[0];e.async=!0,e.src="https://cdn.matomo.cloud/apliqo.matomo.cloud/matomo.js",t.parentNode.insertBefore(e,t)}();`,
            }}
          />
        )}
      </>
    )

  if (pageCategories.includes(`support`))
    return (
      <>
        <Support
          data={props.data}
          pageContext={{ ...props.pageContext, brand: `support` }}
        >
          <div className="row">
            <div className="col">{pageComponents}</div>
          </div>
          <CookieNotice
            personalizeButtonEnable={false}
            personalizeValidationText={"Accept"}
            declineButton={false}
            wrapperClasses={`d-flex justify-content-between`}
          >
            <h4>This websites uses cookies.</h4>
            <p>
              We use cookies on our website to give you the most relevant
              experience by remembering your preferences and repeat visits. By
              clicking “Accept”, you consent to the use of ALL the cookies.
            </p>
          </CookieNotice>
        </Support>
        <Script
          src="https://cdn.jsdelivr.net/gh/recombee/js-api-client@4.0.0/dist/recombee-api-client.min.js"
          onLoad={() => props.recombee.Init()}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NCX94J4');`,
          }}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html: `;(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:5231787,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');;`,
          }}
        />

        <Script src="https://secure.leadforensics.com/js/98460.js" />
        {/* <Script dangerouslySetInnerHTML={{ __html: `;olarkElem = window.document.getElementById('hbl-live-chat-wrapper');if (olarkElem) olarkElem.style.display = "none";` }} /> */}

        {process.env.GATSBY_MATOMO_ID && (
          <Script
            dangerouslySetInnerHTML={{
              __html: `;var _paq=window._paq=window._paq||[];_paq.push(["trackPageView"]),_paq.push(["enableLinkTracking"]),_paq.push(["enableHeartBeatTimer"]),function(){_paq.push(["setTrackerUrl","https://apliqo.matomo.cloud/matomo.php"]),_paq.push(["setSiteId","10"]);var a=document,e=a.createElement("script"),t=a.getElementsByTagName("script")[0];e.async=!0,e.src="https://cdn.matomo.cloud/apliqo.matomo.cloud/matomo.js",t.parentNode.insertBefore(e,t)}();`,
            }}
          />
        )}
      </>
    )

  return (
    <>
      <Cubewise
        data={props.data}
        pageContext={{ ...props.pageContext, brand: `cubewise` }}
      >
        <div className="row">
          <div className="col">
            {pageContentWrapperProps.className.startsWith(
              `tm1-function-for`,
            ) && (
              <TM1FunctionDisplay
                content={page.content}
                pageContext={props.pageContext}
              />
            )}
            {!pageContentWrapperProps.className.startsWith(
              `tm1-function-for`,
            ) && pageComponents}
          </div>
        </div>
        <CookieNotice
          personalizeButtonEnable={false}
          personalizeValidationText={"Accept"}
          declineButton={false}
          wrapperClasses={`d-flex justify-content-between`}
        >
          <h4>This websites uses cookies.</h4>
          <p>
            We use cookies on our website to give you the most relevant
            experience by remembering your preferences and repeat visits. By
            clicking “Accept”, you consent to the use of ALL the cookies.
          </p>
        </CookieNotice>
      </Cubewise>
      <Script
        src="https://cdn.jsdelivr.net/gh/recombee/js-api-client@4.0.0/dist/recombee-api-client.min.js"
        onLoad={() => props.recombee.Init()}
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NCX94J4');`,
        }}
      />

      <Script
        dangerouslySetInnerHTML={{
          __html: `;(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:5231787,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');;`,
        }}
      />

      <Script
        dangerouslySetInnerHTML={{
          __html: `;(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "pydxrgk2gm");;`,
        }}
      />

      <Script src="https://secure.leadforensics.com/Track/Capture.aspx?retType=js&amp;trk_jshv=1&amp;trk_uid=&amp;trk_user=98460&amp;trk_sw=2560&amp;trk_sh=1080&amp;trk_ref=https%3A%2F%2Fcubewise.com%2Fwp-admin%2Findex.php&amp;trk_tit=Homepage%20-%20Cubewise&amp;trk_loc=https%3A%2F%2Fcubewise.com%2F&amp;trk_agn=Netscape&amp;trk_agv=Mozilla%2F5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit%2F537.36%20(KHTML%2C%20like%20Gecko)%20Chrome%2F121.0.0.0%20Safari%2F537.36.lfcd24.lflng&amp;trk_dom=cubewise.com&amp;trk_cookie=NA" />
      {/* <Script dangerouslySetInnerHTML={{ __html: `;olarkElem = window.document.getElementById('hbl-live-chat-wrapper');if (olarkElem) olarkElem.style.display = "none";` }} /> */}

      {process.env.GATSBY_MATOMO_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `;var _paq=window._paq=window._paq||[];_paq.push(["trackPageView"]),_paq.push(["enableLinkTracking"]),_paq.push(["enableHeartBeatTimer"]),function(){_paq.push(["setTrackerUrl","https://apliqo.matomo.cloud/matomo.php"]),_paq.push(["setSiteId","10"]);var a=document,e=a.createElement("script"),t=a.getElementsByTagName("script")[0];e.async=!0,e.src="https://cdn.matomo.cloud/apliqo.matomo.cloud/matomo.js",t.parentNode.insertBefore(e,t)}();`,
          }}
        />
      )}
    </>
  )
}

export const Head = ({ location, params, data, pageContext }) => {
  const page = data.wpPage.nodes[0]

  const excerpt = page.excerpt && parse(page.excerpt).text.trim()

  const description = excerpt || page.title

  let stopIndx = 0
  let stopPunc = `.`
  if (description.length >= 104) {
    stopIndx = 102
    stopPunc = `...`
  } else {
    stopIndx =
      description.indexOf(`.`) === -1
        ? description.length
        : description.lastIndexOf(`.`)
  }

  return (
    <>
      <Seo
        title={page.title}
        description={description.substring(0, stopIndx) + stopPunc}
      />
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-NCX94J4"
          height="0"
          width="0"
          style={{
            display: "none",
            visibility: "hidden",
          }}
        ></iframe>
      </noscript>
    </>
  )
}
export default withRecombee(DefaultPage)

/* DefaultPage.propTypes = {
  data: PropTypes.shape({
    wpPage: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          content: PropTypes.string.isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,

    locales: PropTypes.shape({
      edges: PropTypes.array.isRequired,
    }).isRequired,

    menu: PropTypes.shape({
      menuItems: PropTypes.shape({
        nodes: PropTypes.array.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
} */

export const query = graphql`
  query (
    $slug: String!
    $modalSlugs: [String!]
    $language: String!
    $lang: WpLanguageCodeEnum!
    $headerMenuLocation: WpMenuLocationEnum!
    $footerMenuLocation: WpMenuLocationEnum!
  ) {
    wpPage: allWpPage(
      filter: { slug: { eq: $slug }, language: { slug: { eq: $language } } }
    ) {
      nodes {
        id
        title
        content
        categories {
          nodes {
            name
            slug
          }
        }
      }
    }

    modals: allWpPage(filter: { slug: { in: $modalSlugs } }) {
      nodes {
        id
        slug
        content
      }
    }

    wpPosts: allWpPost(
      filter: { language: { code: { eq: $lang } } }
      limit: 9
      sort: { date: DESC }
    ) {
      nodes {
        id
        databaseId
        date
        title
        excerpt
        slug
        uri
        categories {
          nodes {
            name
          }
        }
        tags {
          nodes {
            name
          }
        }
        author {
          node {
            name
          }
        }
      }
    }

    languages: allWp {
      edges {
        node {
          languages {
            code
            slug
            name
            locale
          }
        }
      }
    }

    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }

    menu: wpMenu(locations: { eq: $headerMenuLocation }) {
      id
      name
      menuItems {
        nodes {
          id
          label
          path
          parentId
          connectedNode {
            node {
              id
              ... on WpPage {
                id
                excerpt
                categories {
                  nodes {
                    name
                    slug
                  }
                }
                subMenuEntries {
                  subMenuPage1 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage2 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage3 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage4 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage5 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage6 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage7 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage8 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage9 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                  subMenuPage91 {
                    subMenuPageName
                    subMenuPageLink {
                      ... on WpPage {
                        uri
                      }
                    }
                  }
                }
                subMenuExternalEntries {
                  subMenuExternalLink1 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink2 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink3 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink4 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink5 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                  subMenuExternalLink6 {
                    subMenuLinkName
                    subMenuLinkUrl
                  }
                }
              }
            }
          }
        }
      }
    }

    footerMenu: wpMenu(locations: { eq: $footerMenuLocation }) {
      id
      name
      menuItems {
        nodes {
          id
          label
          path
          parentId
          connectedNode {
            node {
              id
              ... on WpPage {
                id
                excerpt
              }
            }
          }
        }
      }
    }
  }
`
